import { PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { createAppSlice } from './createAppSlice'

/**
 * Modal state
 */
interface ModalData {
  displayModal: boolean
  modalView: string
  props: any
}

export interface ModalState {
  data: ModalData | null
}
const intialModalState: ModalState = {
  data: {
    modalView: '',
    displayModal: false,
    props: {},
  },
}
export const modalSlice = createAppSlice({
  name: 'modal',
  initialState: intialModalState,
  reducers: {
    setModalView(
      state,
      action: PayloadAction<string | { modalView: string; props?: {} }>,
    ) {
      if (typeof action.payload === 'string') {
        state.data.modalView = action.payload
      } else {
        state.data.modalView = action.payload.modalView
        state.data.props = action.payload.props
      }
    },
    closeModal(state) {
      state.data.displayModal = false
    },
    openModalView(
      state,
      action: PayloadAction<string | { modalView: string; props?: {} }>,
    ) {
      if (typeof action.payload === 'string') {
        state.data.modalView = action.payload
        state.data.displayModal = true
      } else {
        state.data.modalView = action.payload.modalView
        state.data.props = action.payload.props
        state.data.displayModal = true
      }
    },
  },
  selectors: {
    selectModalData: (state) => state.data,
    selectModalView: (state) => state.data?.modalView,
    selectDisplayModal: (state) => state.data?.displayModal,
    selectModalProps: (state) => state.data?.props,
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        //@ts-ignore
        ...action.payload.modal,
      }
    })
  },
})

export const { setModalView, closeModal, openModalView } = modalSlice.actions
export const {
  selectModalData,
  selectDisplayModal,
  selectModalView,
  selectModalProps,
} = modalSlice.selectors

export default modalSlice
